import React, { Component } from "react";
import { convertDateFormat } from "../../utils/helperFunctions";
import { MDBBtn, MDBDataTable } from "mdbreact";
import { Row, Col } from "reactstrap";
import Pagination from "../Common/Pagination";
import { translate } from "react-i18next";

class GatewayTable extends Component {
  state = {
    loadTable: false,
    gatewayList: [],
    pagination: {},
    role: localStorage.getItem("role"),
  };

  columns = [
    {
      label: this.props.t("dashboard.gatewayID"),
      field: "gatewayId",
      sort: "asc",
      width: 250,
    },
    {
      label: this.props.t("dashboard.gatewayName"),
      field: "name",
      sort: "asc",
      width: 250,
    },
    {
      label: this.props.t("dashboard.frequency"),
      field: "loraFreq",
      sort: "asc",
      width: 150,
    },
    {
      label: this.props.t("dashboard.createdAt"),
      field: "createdAt",
      sort: "asc",
      width: 250,
    },
    {
      label: this.props.t("dashboard.action"),
      field: "action",
      width: 80,
    },
  ];
  superAdminColumn = [
    {
      label: this.props.t("dashboard.gatewayID"),
      field: "gatewayId",
      sort: "asc",
      width: 150,
    },
    {
      label: this.props.t("dashboard.name"),
      field: "name",
      sort: "asc",
      width: 200,
    },
    {
      label: this.props.t("dashboard.esp32Last"),
      field: "esp32LastVersion",
      sort: "asc",
      width: 100,
    },
    {
      label: this.props.t("dashboard.esp32New"),
      field: "esp32NewVersion",
      sort: "asc",
      width: 100,
    },
    {
      label: this.props.t("dashboard.loraLast"),
      field: "loraLastVersion",
      sort: "asc",
      width: 100,
    },
    {
      label: this.props.t("dashboard.loraNew"),
      field: "loraNewVersion",
      sort: "asc",
      width: 100,
    },
    {
      label: this.props.t("dashboard.nexationLast"),
      field: "nextionLastVersion",
      sort: "asc",
      width: 100,
    },
    {
      label: this.props.t("dashboard.nexationNew"),
      field: "nextionNewVersion",
      sort: "asc",
      width: 100,
    },
    {
      label: this.props.t("dashboard.loRaOTAStatus"),
      field: "loraMainStatus",
      sort: "asc",
      width: 100,
    },
    {
      label: this.props.t("dashboard.mainESPOTAStatus"),
      field: "mainOtaStatus",
      sort: "asc",
      width: 100,
    },
    {
      label: this.props.t("dashboard.nextionOTAStatus"),
      field: "nextionStatus",
      sort: "asc",
      width: 100,
    },
    {
      label: this.props.t("dashboard.action"),
      field: "action",
      width: 80,
    },
  ];

  componentDidMount() {
    const { gateways } = this.props;
    if (gateways && gateways.length) {
      this.showTable(true);
    } else {
      this.showTable(false);
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.gateways !== this.props.gateways &&
      this.props.gateways &&
      this.props.gateways.length
    ) {
      this.showTable(true);
    }
  }

  showTable = (loadTable) => {
    if (loadTable) {
      const {
        gateways,
        editGateway,
        deleteGateway,
        pagination,
        updateFirmware,
      } = this.props;

      const rows = gateways.map((gateway, index) => {
        let gatewayRow = { ...gateway };
        delete gatewayRow["userId"];
        gatewayRow.createdAt = convertDateFormat(
          gatewayRow.createdAt,
          "shortDateTime"
        );
        gatewayRow.loraFreq = gatewayRow.loraFreq || "N/A";
        gatewayRow.action =
          this.state.role === "super_admin" ? (
            <MDBBtn
              onClick={() => updateFirmware(gateway.gatewayId)}
              tag="a"
              rounded
              size="sm"
              className="px-2 transparentBtn"
            >
              <i className="fas fa-cog mt-0"></i>
            </MDBBtn>
          ) : (
            <>
              <MDBBtn
                onClick={deleteGateway.bind(this, gatewayRow.id)}
                tag="a"
                rounded
                size="sm"
                className="px-2 transparentBtn"
              >
                <i className="fas fa-trash mt-0"></i>
              </MDBBtn>
              <MDBBtn
                onClick={editGateway.bind(this, gatewayRow)}
                tag="a"
                rounded
                size="sm"
                className="px-2 transparentBtn"
              >
                <i className="fas fa-pencil-alt mt-0"></i>
              </MDBBtn>
            </>
          );
        return gatewayRow;
      });
      this.setState({
        loadTable,
        gatewayList: {
          columns:
            this.state.role === "super_admin"
              ? this.superAdminColumn
              : this.columns,
          rows: rows,
        },
        pagination,
      });
    } else {
      this.setState({ loadTable });
    }
  };

  render() {
    const { changePage, t } = this.props;
    const { loadTable, gatewayList, pagination } = this.state;

    return (
      <React.Fragment>
        {loadTable ? (
          <>
            <MDBDataTable
              className="hideLastColSort table-pagination recentAlarmTable border-0"
              bordered
              data={gatewayList}
              paging={true}
              scrollX
              infoLabel={[
                t("dashboard.showing"),
                t("dashboard.to"),
                t("dashboard.of"),
                t("dashboard.result"),
              ]}
              entrieslabel={t("dashboard.showEntries")}
              searchLabel={t("dashboard.search")}
              paginationLabel={[t("dashboard.previous"), t("dashboard.next")]}
            />
            {/* <Row className="mt-3 mb-3">
              <Col lg={6}>
                <label className="ml-3">
                  Showing {pagination.currentPage * 10 - 9} to{" "}
                  {pagination.currentPage * 10} of all results
                </label>
              </Col>
              <Col lg={6} className="text-right">
                <Pagination
                  pagination={pagination}
                  changePage={(page) => changePage(page)}
                ></Pagination>
              </Col>
            </Row> */}
          </>
        ) : null}
      </React.Fragment>
    );
  }
}

export default translate("translations")(GatewayTable);
